export default __webpack_public_path__ + "media/images/casatb/polaroid_right-59195f9f3d416e14c31912833f6e9e67.png";